import { render, staticRenderFns } from "./titelbild.vue?vue&type=template&id=176fb423&scoped=true"
import script from "./titelbild.vue?vue&type=script&lang=js"
export * from "./titelbild.vue?vue&type=script&lang=js"
import style0 from "./titelbild.vue?vue&type=style&index=0&id=176fb423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fb423",
  null
  
)

export default component.exports